import {
  AlignmentType,
  Footer,
  Header,
  ImageRun,
  Paragraph,
  TextRun,
} from "docx";
import { elizalde_header } from "../docImages/elizalde";

export const styles_elizalde = {
  companyId: ["12437"],
  companyName: "Elizalde",
  font: "Calibri",
  titleSize: 19,
  textSize: 18,
  lineSpacing: 360,
  marginRight: 780,
  marginLeft: 780,
  beforeParagraph: 100,

  header: new Header({
    children: [
      new Paragraph({
        spacing: {
          before: 0,
          after: 550,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new ImageRun({
            data: elizalde_header,
            transformation: {
              width: 120,
              height: 90,
            },
          }),
        ],
      }),
    ],
  }),

  footer: new Footer({
    children: [
      new Paragraph({
        spacing: {
          before: 300,
          after: 0,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            text: "CABA: Suipacha 1256 - Tel.: 114167-7980",
            size: 20,
            font: "Times New Roman",
          }),
        ],
      }),
      new Paragraph({
        spacing: {
          before: 60,
          after: 60,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            text: "SAN ISIDRO: 25 de Mayo 159 - Tel.: 113628-6620",
            size: 20,
            font: "Times New Roman",
          }),
        ],
      }),
    ],
  }),
};
